import type {SxProps, Theme} from '@mui/material';

import {orangeColors, semantic} from '../../../../../layouts/theme/designSystem';

const info = semantic.info;

export const culturalFitPaperSx: SxProps<Theme> = {
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '14px',
  p: 2.5,
  mb: 2.5,
};

export const culturalFitPillarTabRowSx: SxProps<Theme> = {
  display: 'flex',
  gap: 0,
  borderBottom: `1px solid ${orangeColors[3]}`,
  mb: 2,
  flexWrap: 'wrap',
};

export const getCulturalFitPillarTabSx = (isActive: boolean): SxProps<Theme> => ({
  px: 1.5,
  py: 1,
  fontSize: 12.5,
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontWeight: isActive ? 500 : 400,
  color: isActive ? info.fg : 'text.secondary',
  background: 'none',
  border: 'none',
  borderBottom: `2px solid ${isActive ? info.fg : 'transparent'}`,
  mb: '-1px',
  transition: 'all 0.13s',
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  '&:hover': {color: 'text.primary'},
});

export const getCulturalFitPillarOverlapSx = (isActive: boolean): SxProps<Theme> => ({
  fontSize: 10,
  fontWeight: 600,
  px: 0.75,
  py: '1px',
  borderRadius: '99px',
  lineHeight: 1.4,
  bgcolor: isActive ? info.bg : orangeColors[5],
  color: isActive ? info.fg : 'text.secondary',
  border: `0.5px solid ${isActive ? info.fg : orangeColors[3]}`,
});

export const culturalFitCollapsedCultureChipSx: SxProps<Theme> = {
  bgcolor: info.bg,
  color: info.fg,
  fontWeight: 600,
  height: 22,
};

export const culturalFitExpandIconSx = (expanded: boolean): SxProps<Theme> => ({
  fontSize: 22,
  color: info.fg,
  transform: expanded ? 'rotate(180deg)' : 'none',
  transition: 'transform 0.2s ease',
});

export const culturalFitSectionHeadingSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 1.5,
};

export const culturalFitDetailSectionBlockSx: SxProps<Theme> = {
  mb: 1.5,
};

export const culturalFitDetailSectionLabelSx: SxProps<Theme> = {
  fontWeight: 600,
  color: info.fg,
  display: 'block',
  mb: 0.5,
};

export const culturalFitDetailSectionListSx: SxProps<Theme> = {
  m: 0,
  pl: 2.5,
};

export const culturalFitDetailListItemSx: SxProps<Theme> = {
  lineHeight: 1.6,
  mb: 0.5,
};

export const getCulturalFitHeaderSx = (isOpen: boolean, alwaysExpanded: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2,
  mb: isOpen ? 2 : 0,
  ...(!alwaysExpanded && {cursor: 'pointer', userSelect: 'none'}),
});
